module.exports = __webpack_public_path__ + "static/media/google_play_store_en.149fd5e0.svg";